import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { JSX } from "react";

export const CertificateExpiryHeader = (): JSX.Element | null => {
    return (
        <div className="p-certificate-expiry__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /{" "}
                    <Link to={RouteEnum.QUALIFICATIONS}>Kwalificaties</Link> /{" "}
                    <Link to={RouteEnum.CERTIFICATE_EXPIRY}>
                        Verloopt binnenkort
                    </Link>
                </span>
            </div>
            <div className="c-header-search">
                <div className="c-header-search__title">
                    <h2>Verloopt binnenkort</h2>
                </div>
            </div>
        </div>
    );
};
